<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Task name</label>
          <b-form-input
              type="text"
              :state="informationValidation.isTaskNameProvided"
              v-model="personalTaskDetails.taskName"></b-form-input>

          <b-form-invalid-feedback v-if="!informationValidation.isTaskNameProvided">
            This field must not be empty.
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">To-do list name</label>
          <b-form-input
              type="text"
              v-model="personalTaskDetails.toDoListName"
              disabled></b-form-input>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Priority</label>
          <b-form-select v-model="personalTaskDetails.priority" :options="priorityOptions"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Description</label>
          <b-form-input
              type="text"
              v-model="personalTaskDetails.description"></b-form-input>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Due date</label>
          <b-form-datepicker
              v-model="personalTaskDetails.dueDate"></b-form-datepicker>
          <b-button v-if="personalTaskDetails.dueDate" variant="outline-danger" @click="removeDueDate"
                    id="removeDueDateButton">
            Remove due date
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Location</label>
          <b-form-input
              type="text"
              v-model="personalTaskDetails.location"></b-form-input>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Reminder</label>
          <b-form-datepicker
              disabled></b-form-datepicker>
          <b-form-text>The task reminder can only be configured from the mobile application.</b-form-text>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label>at</label>
          <b-form-timepicker
              disabled></b-form-timepicker>
          <b-form-text>The task reminder can only be configured from the mobile application.</b-form-text>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Attachment</label>
          <br>
          <input type="file" accept="image/*" @change="onFileChange" id="attachment-input"/>
          <b-button v-if="attachmentUrl" variant="outline-danger" @click="removeAttachment"
                    id="removeAttachmentButton">
            Remove attachment
          </b-button>
          <div id="preview">
            <img v-if="attachmentUrl" :src="attachmentUrl"/>
          </div>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="createPersonalTask">Create task</b-button>
  </div>
</template>

<script>
  import {required} from "vuelidate/lib/validators";

  export default {
    name: "PersonalTaskCreation.vue",
    data() {
      return {
        personalTaskDetails: {
          toDoListId: null,
          taskName: null,
          toDoListName: this.$store.getters.currentToDoListName,
          priority: 1,
          description: null,
          dueDate: null,
          location: null,
          reminderDate: null,
          attachmentFile: null,
          taskType: 'Personal Task'
        },
        informationValidation: {
          isTaskNameProvided: null
        },
        priorityOptions: [
          {value: 0, text: 'High'},
          {value: 1, text: 'Medium'},
          {value: 2, text: 'Low'}
        ],
        attachmentUrl: null
      }
    },
    validations: {
      personalTaskDetails: {
        taskName: {
          required
        }
      }
    },
    methods: {
      onFileChange(e) {
        this.personalTaskDetails.attachmentFile = e.target.files[0];

        if (this.personalTaskDetails.attachmentFile !== undefined) {
          this.attachmentUrl = URL.createObjectURL(this.personalTaskDetails.attachmentFile);
        } else {
          this.attachmentUrl = null
        }
      },
      removeAttachment() {
        this.attachmentUrl = null
        document.getElementById("attachment-input").value = "";
      },
      removeDueDate() {
        this.personalTaskDetails.dueDate = null
      },
      createPersonalTask() {
        // check if all information is valid
        let isValid = true

        if (!this.$v.personalTaskDetails.taskName.required) {
          this.informationValidation.isTaskNameProvided = false
          isValid = false
        } else {
          this.informationValidation.isTaskNameProvided = true
        }

        if (isValid) {
          if (this.$route.name === 'Inbox') {
            this.personalTaskDetails.toDoListId = this.$store.getters.inboxToDoListId

            this.$store.dispatch('createNewPersonalTask', this.personalTaskDetails)
            this.hideModal('creation-modal')
          } else if (this.$route.name === 'Personal Task List') {
            this.personalTaskDetails.toDoListId = this.$route.params.personalListId

            this.$store.dispatch('createNewPersonalTask', this.personalTaskDetails)
            this.hideModal('creation-modal')
          }
        }
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    }
  }
</script>

<style scoped>
  #removeDueDateButton {
    margin-top: 1em;
  }

  #removeAttachmentButton {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  #preview {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #preview img {
    max-width: 100%;
    max-height: 500px;
  }

  .add-attachment-button {
    display: block;
  }

  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .secondary-input-button {
    background-color: white;
    color: #212441;
    padding: 0.5em;
  }

  .secondary-input-button:hover {
    background-color: #212441;
    color: white;
    padding: 0.5em;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
